<template>
  <v-container fluid>
    <v-card>
      <v-container class="ma-0 pa-0" fluid>
        <v-container grid-list-xs fluid class="mb-0 pb-0" style="padding: 0px;">
          <v-layout row style="padding: 10px;">
            <v-layout>
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="Date From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="dateTo"
                    min="1950-01-01"
                    @input="menu = false"
                    @change="checkDateFrom($event)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="Date To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    :min="dateFrom"
                    @input="menu1 = false"
                    @change="checkDateTo($event)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>

            <v-spacer></v-spacer>

            <v-btn fab dark small color="amber darken-2" @click="getData">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel File</span>
            </v-tooltip>
            <refresh-button @refresh="refreshTable()"></refresh-button>
          </v-layout>
        </v-container>

        <v-layout row>
          <v-flex sm4 md4> </v-flex>

          <v-flex sm8 md8> </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align,
                ]"
              >
                <span>{{ header.text.toUpperCase() }}</span>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center" data-v-273e1c39>
              {{ props.index + 1 }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{
                props.item.vehicle_no == "null" ? "-" : props.item.vehicle_no
              }}
            </td>
            <td class="text-xs-right">{{ props.item.total_days }}</td>
            <!-- <td class="text-xs-right">
              {{ $amountInPeso(props.item.gross_revenue) }}
            </td> -->
            <td class="text-xs-center" v-if="loadingTickets">
              <v-progress-circular
                indeterminate
                color="green"
                :size="25"
              ></v-progress-circular>
            </td>
            <!-- <td v-else>{{ $amountInPeso(props.item.cash_sales) }}</td> -->
            <td class="text-xs-center" v-if="loadingTickets">
              <v-progress-circular
                indeterminate
                color="green"
                :size="25"
              ></v-progress-circular>
            </td>
            <!-- <td v-else>{{ $amountInPeso(props.item.card_sales) }}</td> -->
            <!-- <td class="text-xs-right">
              {{ $amountInPeso(props.item.reserved_sales) }}
            </td> -->
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.baggage_sales) }}
            </td>
            <td class="text-xs-center" v-if="loadingTickets">
              <v-progress-circular
                indeterminate
                color="green"
                :size="25"
              ></v-progress-circular>
            </td>
            <!-- <td class="text-xs-right" v-else>
              {{ $amountInPeso(props.item.baggage_cash_sales) }}
            </td> -->
            <td class="text-xs-center" v-if="loadingTickets">
              <v-progress-circular
                indeterminate
                color="green"
                :size="25"
              ></v-progress-circular>
            </td>
            <!-- <td class="text-xs-right" v-else>
              {{ $amountInPeso(props.item.baggage_card_sales) }}
            </td> -->
            <!-- <template v-if="loadingExpenses">
              <td
                class="text-xs-right"
                data-v-273e1c39
                v-for="(expensesItem, index) in props.item.expenses"
                :key="index"
              >
                <v-progress-circular
                  indeterminate
                  color="green"
                  :size="25"
                ></v-progress-circular>
              </td>
            </template> -->
            <!-- <template v-else>
              <td
                class="text-xs-right"
                data-v-273e1c39
                v-for="(expensesItem, index) in props.item.expenses"
                :key="index"
              >
                {{ $amountInPeso(expensesItem.amount) }}
              </td>
            </template> -->
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.partials) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.net_remittance) }}
            </td>
            <td class="text-xs-right">
              {{
                $amountInPeso(props.item.final_cash ? props.item.final_cash : 0)
              }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.cash_received) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.short_over) }}
            </td>
          </template>
          <template v-if="items.length !== 0" slot="footer">
            <td class="text-xs-right font-weight-bold">Total:</td>
            <td class="text-xs-right">{{ totalItems.vehicles }}</td>
            <td class="text-xs-right">{{ totalItems.total_days }}</td>
            <!-- <td class="text-xs-right">
              {{ $amountInPeso(totalItems.gross_revenue) }}
            </td> -->
            <td class="text-xs-center" v-if="loadingTickets">
              <v-progress-circular
                indeterminate
                color="green"
                :size="25"
              ></v-progress-circular>
            </td>
            <!-- <td v-else>{{ $amountInPeso(totalItems.cash_sales) }}</td> -->
            <td class="text-xs-center" v-if="loadingTickets">
              <v-progress-circular
                indeterminate
                color="green"
                :size="25"
              ></v-progress-circular>
            </td>
            <!-- <td v-else>{{ $amountInPeso(totalItems.card_sales) }}</td> -->
            <!-- <td class="text-xs-right">
              {{ $amountInPeso(totalItems.reserved_sales) }}
            </td> -->
            <td class="text-xs-right">
              {{ $amountInPeso(totalItems.baggage_sales) }}
            </td>
            <td class="text-xs-center" v-if="loadingBaggage">
              <v-progress-circular
                indeterminate
                color="green"
                :size="25"
              ></v-progress-circular>
            </td>
            <!-- <td class="text-xs-right" v-else>
              {{ $amountInPeso(totalItems.baggage_cash_sales) }}
            </td> -->
            <td class="text-xs-center" v-if="loadingBaggage">
              <v-progress-circular
                indeterminate
                color="green"
                :size="25"
              ></v-progress-circular>
            </td>
            <!-- <td class="text-xs-right" v-else>
              {{ $amountInPeso(totalItems.baggage_card_sales) }}
            </td> -->
            <!-- <template v-if="loadingExpenses">
              <td
                class="text-xs-right"
                data-v-273e1c39
                v-for="(expensesTotals, index) in totalItems.expenses"
                :key="index"
              >
                <v-progress-circular
                  indeterminate
                  color="green"
                  :size="25"
                ></v-progress-circular>
              </td>
            </template> --> 
            <!-- <template v-else>
              <td
                class="text-xs-right"
                data-v-273e1c39
                v-for="(expensesTotals, index) in totalItems.expenses"
                :key="index"
              >
                {{ $amountInPeso(expensesTotals.amount) }}
              </td>
            </template> -->
            <td class="text-xs-right">
              {{ $amountInPeso(totalItems.partials) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(totalItems.net_remittance) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(totalItems.final_cash) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(totalItems.cash_received) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(totalItems.short_over) }}
            </td>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import XLSX from "xlsx";
const now = new Date();
import dateRangeFunctions from "@/utils/dateRangeFunctions";

export default {
  created() {
    // this.getExpensesTypes();
  },
  data() {
    return {
      title: "Remittance Report",
      timeOut: null,
      theTableStyle: false,
      tableItems: [
        {
          text: "Default Table",
          value: false,
        },
        {
          text: "Grid Style Table",
          value: true,
        },
      ],
      headers: [],
      items: [],
      totalItems: {},
      queryParams: {
        search: "",
        company_id: null,
        sub_company_id: null,
        date_from: null,
        date_to: null,
      },
      menu: false,
      menu1: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      remittanceIDs: [],
      expensesTypes: [],
      remittanceSummary: [],
      ticketSummary: [],
      expenseSummary: [],
      baggageSummary: [],
      loadingTickets: false,
      loadingExpenses: false,
      loadingBaggage: false,
      totalIems: {},
    };
  },
  methods: {
    async getData() {
      // Start Loading
      this.$store.dispatch("startLoading");

      this.remittanceIDs = [];
      this.expensesTypes = [];
      this.remittanceSummary = [];
      this.ticketSummary = [];
      this.expenseSummary = [];
      this.baggageSummary = [];

      this.items = [];
      this.totalIems = [];

      try {
        // Query Data
        await this.getExpensesTypes();
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
    },
   async checkDateFrom(event) {
      this.dateTo = await dateRangeFunctions.checkFrom7DayStrict(
        event,
        this.dateFrom,
        this.dateTo
      );
    },
   async checkDateTo(event) {
      this.dateFrom = await dateRangeFunctions.checkTo7DayStrict(
        event,
        this.dateFrom,
        this.dateTo
      );
    },   
    async getExpensesTypes() {
      this.$store.dispatch("startLoading");
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      try {
        let response = (await Services.getExpensesTypes(this.queryParams)).data;

        this.expensesTypes = response.data;

        const headers = [
          { text: "#", align: "center", sortable: false },
          // Add your Header BELOW
          {
            text: "Store Name",
            align: "left",
            sortable: false,
          },
          {
            text: "Total Device Usage",
            align: "right",
            sortable: false,
          },
          // {
          //   text: "Gross Revenue",
          //   align: "right",
          //   sortable: false,
          // },
          // {
          //   text: "Passenger Cash Sales",
          //   align: "right",
          //   sortable: false,
          // },
          // {
          //   text: "Passenger Card Sales",
          //   align: "right",
          //   sortable: false,
          // },
          // {
          //   text: "Reserved Sales",
          //   align: "right",
          //   sortable: false,
          // },
          {
            text: "Gross Sales",
            align: "right",
            sortable: false,
          },
          // {
          //   text: "Baggage Cash Sales",
          //   align: "right",
          //   sortable: false,
          // },
          // {
          //   text: "Baggage Card Sales",
          //   align: "right",
          //   sortable: false,
          // },
          {
            text: "Partial Remittance",
            align: "right",
            sortable: false,
          },
          {
            text: "Net Remittance",
            align: "right",
            sortable: false,
          },
          {
            text: "Final Cash",
            align: "right",
            sortable: false,
          },
          {
            text: "Cash Received",
            align: "right",
            sortable: false,
          },
          {
            text: "Short/Over",
            align: "right",
            sortable: false,
          },
        ];
        let forHeader = [];

        // this.expensesTypes.forEach((item) => {
        //   forHeader.splice(0, 0, {
        //     text: this.$capitalizeFirstLetter(item.name),
        //     align: "right",
        //     sortable: false,
        //   });
        // });

        // forHeader.forEach((item) => {
        //   headers.splice(10, 0, {
        //     text: item.text,
        //     align: item.align,
        //     sortable: item.sortable,
        //   });
        // });

        this.headers = headers;

        this.getRemittanceIds();
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
        this.$store.dispatch("endLoading");
      }
    },
    async getRemittanceIds() {
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom;
      this.queryParams.date_to = this.dateTo;

      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      try {
        let response = (await Services.getRemittanceIds(this.queryParams)).data;

        const remIDs = await response.data.map((item) => {
          if (
            item.id !== "" ||
            item.id !== "" ||
            item.id !== null ||
            item.id !== undefined
          ) {
            return `'${item.id}'`;
          }
        });

        this.remittanceIDs = remIDs.join(",");

        await this.getRemittanceSummary();
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
        this.$store.dispatch("endLoading");
      }
    },
    async getRemittanceSummary() {
      this.$store.dispatch("startLoading");

      const body = {
        remittanceIDs: this.remittanceIDs,
      };

      try {
        let response = (await Services.getRemittanceSummary(body)).data;

        this.remittanceSummary = response.data;

        if (this.remittanceSummary) {
          await this.displayRemittanceSummary();
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
        this.$store.dispatch("endLoading");
      }
    },
    async getTicketSummary() {
      this.$store.dispatch("startLoading");

      const body = {
        remittanceIDs: this.remittanceIDs,
      };
      this.loadingTickets = true;

      try {
        let response = (await Services.getTicketSummary(body)).data;

        this.ticketSummary = response.data;

        await this.displayTicketSummary();
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
        this.loadingTickets = false;
        this.$store.dispatch("endLoading");
      }
    },
    async getBaggageSummary() {
      this.$store.dispatch("startLoading");

      const body = {
        remittanceIDs: this.remittanceIDs,
      };
      this.loadingBaggage = true;

      try {
        let response = (await Services.getBaggageSummary(body)).data;

        this.baggageSummary = response.data;

        await this.displayBaggageSummary();
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
        this.loadingBaggage = false;
        this.$store.dispatch("endLoading");
      }
    },
    async displayRemittanceSummary() {
      if (this.remittanceSummary.length > 0) {
        const group = this.groupBy(this.remittanceSummary, "vehicle_name");

        let finalData = [];

        let total = {
          total_days: 0,
          gross_revenue: 0,
          cash_sales: 0,
          card_sales: 0,
          baggage_sales: 0,
          baggage_cash_sales: 0,
          baggage_card_sales: 0,
          reserved_sales: 0,
          partials: 0,
          net_remittance: 0,
          final_cash: 0,
          cash_received: 0,
          short_over: 0,
          expenses: this.expensesTypes,
        };
        if (Object.keys(group)) {
          for (let i = 0; i < Object.keys(group).length; i++) {
            let data = {
              vehicle_no: Object.keys(group)[i],
              total_days: 0,
              gross_revenue: 0,
              cash_sales: 0,
              card_sales: 0,
              baggage_sales: 0,
              baggage_cash_sales: 0,
              baggage_card_sales: 0,
              reserved_sales: 0,
              partials: 0,
              net_remittance: 0,
              final_cash: 0,
              cash_received: 0,
              short_over: 0,
              expenses: this.expensesTypes.length > 0 ? this.expensesTypes : [],
            };
            if (group[Object.keys(group)[i]]) {
              for (
                let itemR = 0;
                itemR < group[Object.keys(group)[i]].length;
                itemR++
              ) {
                let item = group[Object.keys(group)[i]][itemR];
                data.total_days += +item.total_device_count;
                data.gross_revenue += item.gross_revenue;
                data.partials += item.total_partial;
                data.net_remittance += item.net_remittance;
                data.final_cash += item.final_cash;
                data.cash_received += item.cash_received;
                data.short_over += item.short_over;
                data.baggage_sales += item.baggage_gross;
                total.total_days += +item.total_device_count;
                total.gross_revenue += item.gross_revenue;
                total.partials += item.total_partial;
                total.net_remittance += item.net_remittance;
                total.final_cash += item.final_cash;
                total.cash_received += item.cash_received;
                total.short_over += item.short_over;
                total.baggage_sales += item.baggage_gross;
              }
            }
            finalData.push(data);
          }
          this.items = finalData;
          this.totalItems = total;
        }
        await this.getTicketSummary();
      }
    },
    async displayTicketSummary() {
      const group = this.groupBy(this.remittanceSummary, "vehicle_name");

      let total = {
        cash_sales: 0,
        card_sales: 0,
        reserved_sales: 0,
      };

      // if (Object.keys(group)) {
      for (let i = 0; i < Object.keys(group).length; i++) {
        const vehicle = Object.keys(group)[i];

        let data = {
          vehicle_no: vehicle,
          cash_sales: 0,
          card_sales: 0,
          reserved_sales: 0,
        };

        for (let itemT = 0; itemT < this.ticketSummary.length; itemT++) {
          const item = this.ticketSummary[itemT];

          const checkVehicle = item.vehicle_name === vehicle;

          if (item.name == "card" && checkVehicle) {
            data.card_sales += item.sum;
            total.card_sales += item.sum;
          }
          if (item.name == "cash" && checkVehicle) {
            data.cash_sales += item.sum;
            total.cash_sales += item.sum;
          }
          if (item.name == "reserved" && checkVehicle) {
            data.reserved_sales += item.sum;
            total.reserved_sales += item.sum;
          }
        }

        this.items[i].card_sales = data.card_sales;
        this.items[i].cash_sales = data.cash_sales;
        this.items[i].reserved_sales = data.reserved_sales;
      }
      this.totalItems.card_sales = total.card_sales;
      this.totalItems.cash_sales = total.cash_sales;
      this.totalItems.reserved_sales = total.reserved_sales;
      // }

      this.loadingTickets = false;
      await this.getBaggageSummary();
    },
    async displayBaggageSummary() {
      const group = this.groupBy(this.remittanceSummary, "vehicle_name");

      let total = {
        baggage_cash_sales: 0,
        baggage_card_sales: 0,
        baggage_sales: 0,
      };

      for (let i = 0; i < Object.keys(group).length; i++) {
        const vehicle_name = Object.keys(group)[i];

        let data = {
          vehicle_no: vehicle_name,
          baggage_cash_sales: 0,
          baggage_card_sales: 0,
          baggage_sales: 0,
        };

        for (let itemB = 0; itemB < this.baggageSummary.length; itemB++) {
          const item = this.baggageSummary[itemB];

          const checkVehicle = item.vehicle_name === vehicle_name;

          if (item.transaction_type == 0 && checkVehicle) {
            data.baggage_cash_sales += item.sum;
            data.baggage_sales += item.sum;
            total.baggage_cash_sales += item.sum;
            total.baggage_sales += item.sum;
          }
          if (item.transaction_type == 1 && checkVehicle) {
            data.baggage_card_sales += item.sum;
            data.baggage_sales += item.sum;
            total.baggage_card_sales += item.sum;
            total.baggage_sales += item.sum;
          }
        }

        if (this.items[i].baggage_sales == 0) {
          this.items[i].baggage_sales = data.baggage_sales;
        }

        this.items[i].baggage_cash_sales = data.baggage_cash_sales;
        this.items[i].baggage_card_sales = data.baggage_card_sales;
      }

      this.totalItems.baggage_cash_sales = total.baggage_cash_sales;
      this.totalItems.baggage_card_sales = total.baggage_card_sales;
      if (this.totalItems.baggage_sales == 0) {
        this.totalItems.baggage_sales = total.baggage_sales;
      }

      this.loadingBaggage = false;

      await this.getExpensesSummary();
    },
    async getExpensesSummary() {
      this.$store.dispatch("startLoading");
      this.loadingExpenses = true;

      const body = {
        remittanceIDs: this.remittanceIDs,
      };

      try {
        let response = (await Services.getExpensesSummary(body)).data;

        this.expenseSummary = response.data;

        await this.displayExpensesSummary();
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
        this.$store.dispatch("endLoading");
        this.loadingExpenses = false;
      }
      if (!this.expenseSummary.length > 0) {
        this.loadingExpenses = false;
      }
    },
    async displayExpensesSummary() {
      if (this.expenseSummary.length > 0) {
        const group = this.groupBy(this.remittanceSummary, "vehicle_name");
        const transactionGroup = this.groupBy(
          this.ticketSummary,
          "vehicle_name"
        );

        let total = {
          expenses: [],
        };

        if (Object.keys(group)) {
          for (let i = 0; i < Object.keys(group).length; i++) {
            let data = {
              vehicle_no: Object.keys(group)[i],
              expenses: [],
            };
            this.expensesTypes.map((passType) => {
              let dataPass = {
                index: passType.index,
                name: passType.name,
                amount: 0,
              };
              transactionGroup[Object.keys(group)[i]] &&
                transactionGroup[Object.keys(group)[i]].map((itemR1) => {
                  this.expenseSummary.map((passData) => {
                    if (
                      itemR1.remittance_sync_id ===
                        passData.remittance_sync_id &&
                      passType.name == passData.expense_type
                    ) {
                      dataPass.amount += passData.amount;
                    }
                  });
                });
              data.expenses.push(dataPass);
              total.expenses.push(dataPass);
            });
            this.loadingExpenses = false;
            this.items[i].expenses = data.expenses;
          }
        }

        let totalExpenses = [];

        total.expenses.reduce(function(res, value) {
          if (!res[value.name]) {
            res[value.name] = { name: value.name, amount: 0 };
            totalExpenses.push(res[value.name]);
          }
          res[value.name].amount += value.amount;
          return res;
        }, {});

        this.totalItems.expenses = totalExpenses;
      }
      this.$store.dispatch("endLoading");
    },

    refreshTable() {
      this.remittanceIDs = [];
      this.expensesTypes = [];
      this.remittanceSummary = [];
      this.ticketSummary = [];
      this.expenseSummary = [];
      this.baggageSummary = [];

      this.items = [];
      this.totalItems = [];

      this.dateFrom = this.$dateFormat(now, "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(now, "YYYY-MM-DD");

      this.getData();
    },
    groupBy(array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    downloadExcel() {
      const wscols = [];
      const dataToDownload = [];
      const header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();
      header.unshift("");
      dataToDownload.push(header);

      for (let i = 0; i < this.headers.length; i++) {
        wscols.push({ wch: 15 });
      }

      for (let e = 0; e < this.items.length; e++) {
        const theItem = [];

        theItem.push("");
        theItem.push(
          this.items[e].vehicle_no
            ? this.items[e].vehicle_no.toUpperCase()
            : "--"
        );
        theItem.push(this.items[e].total_days);
        // theItem.push(this.items[e].gross_revenue);
        // theItem.push(this.items[e].cash_sales);
        // theItem.push(this.items[e].card_sales);
        // theItem.push(this.items[e].reserved_sales);
        theItem.push(this.items[e].baggage_sales);
        // theItem.push(this.items[e].baggage_cash_sales);
        // theItem.push(this.items[e].baggage_card_sales);
        // for (let i = 0; i < this.items[e].expenses.length; i++) {
        //   theItem.push(this.items[e].expenses[i].amount);
        // }
        theItem.push(this.items[e].partials);
        theItem.push(this.items[e].net_remittance);
        theItem.push(this.items[e].final_cash);
        theItem.push(this.items[e].cash_received);
        theItem.push(this.items[e].short_over);

        dataToDownload.push(theItem);
      }

      // for (let e = 0; e < 2; e++) {
      //   const theItem_2 = [];

      //   theItem_2.push("");
      //   theItem_2.push("");
      //   theItem_2.push("");
      //   theItem_2.push("");
      //   theItem_2.push("");
      //   theItem_2.push("");
      //   theItem_2.push("");
      //   theItem_2.push("");
      //   theItem_2.push("");
      //   for (let j = 0; j < this.items.length; j++) {
      //     for (let i = 0; i < this.items[j].expenses.length; i++) {
      //       theItem_2.push("");
      //     }
      //   }

      //   dataToDownload.push(theItem_2);
      // }

      const totalItems = [
        "TOTAL",
        "",
        this.totalItems.total_days,
        // this.totalItems.gross_revenue,
        // this.totalItems.cash_sales,
        // this.totalItems.card_sales,
        // this.totalItems.reserved_sales,
        this.totalItems.baggage_sales,
        // this.totalItems.baggage_cash_sales,
        // this.totalItems.baggage_card_sales,
        this.totalItems.partials,
        this.totalItems.net_remittance,
        this.totalItems.final_cash,
        this.totalItems.cash_received,
        this.totalItems.short_over,
      ];

      const array = [];

      // for (let e = 0; e < this.totalItems.expenses.length; e++) {
      //   array.splice(0, 0, this.totalItems.expenses[e]);
      // }

      for (let e = 0; e < array.length; e++) {
        totalItems.splice(10, 0, array[e].amount);
      }

      dataToDownload.push(totalItems);

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      // var fmt = "#,##0";

      // This is format down here is the two decimal places format...

      // var fmt = "0.00#";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;

          // Specific format for the cell...

          if (header[C] === "TOTAL DEVICE USAGE") {
            ws[ref].z = "#,##0";
          } else {
            ws[ref].z = "#,##0.00#";
          }
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>

<style scoped>
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
